"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function Header(_ref) {
  var className = _ref.className,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("h1", {
    className: (0, _classnames["default"])('text-2xl md:text-4xl font-bold text-dark', className)
  }, children);
}
var _default = exports["default"] = Header;
//# sourceMappingURL=Header.js.map